import React, { Component } from 'react';
import PropTypes from 'prop-types';

const getClassNameUsingTracking = tracking => `checkbox__input ${tracking}`;

class FormCheckBox extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    tracking: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    id: '',
    tracking: '',
    checked: false
  };

  state = {
    isChecked: !!this.props.checked
  };

  handleClick = () => {
    this.setState(
      {
        isChecked: !this.state.isChecked
      },
      () => {
        this.props.onChange(this.state.isChecked);
      }
    );
  };

  render() {
    return (
      <div className="checkbox">
        <input
          className={getClassNameUsingTracking(this.props.tracking)}
          type="checkbox"
          id={this.props.id}
          onChange={this.handleClick}
          checked={this.state.isChecked}
        />
        <label className="checkbox__label" htmlFor={this.props.id}>
          {this.props.label}
        </label>
      </div>
    );
  }
}

export default FormCheckBox;
